"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Pagination["default"];
  }
});

var _Pagination = _interopRequireDefault(require("./Pagination"));


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/addons/Pagination/index.js
// module id = 833
// module chunks = 0